import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellSpace from "ds/components/Table/Row/CellSpace";
import { SpaceAccessLevel } from "types/generated";
import { StackRoleBindingView } from "shared/Stack/Roles/types";

const StackRolesSpaceCell = ({
  item: roleBinding,
  ...cellProps
}: TableSimpleCellProps<StackRoleBindingView>) => {
  const hasAccessToSpace = roleBinding.space.accessLevel !== SpaceAccessLevel.None;

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellSpace
        href={`/spaces/${roleBinding.space.id}`}
        disabled={!hasAccessToSpace}
        tooltip={!hasAccessToSpace ? "You don't have access to this space" : undefined}
      >
        {roleBinding.space.name}
      </TableCellSpace>
    </TableSimpleCell>
  );
};

export default StackRolesSpaceCell;
